// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationProcedureTaskId } from './FermentationProcedureTask';
import { fermentationStatusEnum } from './FermentationStatusEnum';
import { fermentationTaskStatusEnum } from './FermentationTaskStatusEnum';
import { operatorId } from './Operator';
import { fermentationGroupId } from './FermentationGroup';
import { brewcontrolCalibrationId } from './BrewcontrolCalibration';
import { z } from 'zod';
export const fermentationGroupTaskId = (z.number());
export const fermentationGroupTask = z.object({
    id: fermentationGroupTaskId,
    procedure_task_id: fermentationProcedureTaskId.nullable(),
    title: z.string(),
    instructions: z.string().nullable(),
    target_status: fermentationStatusEnum.nullable(),
    status: fermentationTaskStatusEnum,
    completed_at: z.date().nullable(),
    completed_by: operatorId.nullable(),
    notes: z.string().nullable(),
    display_order: z.number(),
    created_at: z.date(),
    created_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
    fermentation_group_id: fermentationGroupId.nullable(),
    calibration_target_key: z.string().nullable(),
    calibration_id: brewcontrolCalibrationId.nullable(),
});
export const fermentationGroupTaskInitializer = z.object({
    id: fermentationGroupTaskId.optional(),
    procedure_task_id: fermentationProcedureTaskId.optional().nullable(),
    title: z.string(),
    instructions: z.string().optional().nullable(),
    target_status: fermentationStatusEnum.optional().nullable(),
    status: fermentationTaskStatusEnum.optional(),
    completed_at: z.date().optional().nullable(),
    completed_by: operatorId.optional().nullable(),
    notes: z.string().optional().nullable(),
    display_order: z.number().optional(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    fermentation_group_id: fermentationGroupId.optional().nullable(),
    calibration_target_key: z.string().optional().nullable(),
    calibration_id: brewcontrolCalibrationId.optional().nullable(),
});
export const fermentationGroupTaskMutator = z.object({
    id: fermentationGroupTaskId.optional(),
    procedure_task_id: fermentationProcedureTaskId.optional().nullable(),
    title: z.string().optional(),
    instructions: z.string().optional().nullable(),
    target_status: fermentationStatusEnum.optional().nullable(),
    status: fermentationTaskStatusEnum.optional(),
    completed_at: z.date().optional().nullable(),
    completed_by: operatorId.optional().nullable(),
    notes: z.string().optional().nullable(),
    display_order: z.number().optional(),
    created_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    fermentation_group_id: fermentationGroupId.optional().nullable(),
    calibration_target_key: z.string().optional().nullable(),
    calibration_id: brewcontrolCalibrationId.optional().nullable(),
});
//# sourceMappingURL=FermentationGroupTask.js.map